<template>
  <c-sheet color="secondary-800" class="pa-2">
    <div
      :class="[
        'd-flex align-center mb-3',
        { 'justify-center': isMiniSidebarShown }
      ]"
    >
      <v-avatar size="20px">
        <v-img :src="managerInfo.avatar" alt="manager avatar">
          <template #placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="secondary-100" />
            </v-row>
          </template>
        </v-img>
      </v-avatar>
      <div v-if="!isMiniSidebarShown" class="text-body-2 ml-3">
        <div class="height-14 text-white">
          {{ managerInfo.name }}
        </div>
        <div class="text-caption height-14 text-secondary-400 mt-1">
          {{ managerInfo.description  }}
        </div>
      </div>
    </div>
    <manager-contacts
      :manager-info="managerInfo"
      is-compact
      :is-minimized="isMiniSidebarShown"
    />
  </c-sheet>
</template>

<script>
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'
  import { CSheet } from '@clickadilla/components/components'
  import ManagerContacts from '@/components/PersonalManagerCard/ManagerContacts.vue'

  export default {
    name: 'PersonalCompactCard',
    components: { ManagerContacts, CSheet },
    props: {
      managerInfo: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['isMiniSidebarShown'])
    }
  }
</script>

<style scoped lang="scss">
.height-14 {
  line-height: 14px;
}
</style>
